export const LOCATIONS_KEY = 'locations';

const all = [LOCATIONS_KEY];

export const locationsKey = {
  all,
  lists: token => [...all, 'list', token],
  listWithPagination: (
    token,
    pageSize,
    pageToken,
    pageNumber,
    method,
    companyId
  ) => [
    ...all,
    'list',
    token,
    'pagination',
    { pageSize, pageToken, pageNumber, method, companyId }
  ],
  detail: (token, locationId) => [...all, 'detail', token, locationId],
  accessLevels: (token, locationId) => [
    ...all,
    'access-levels',
    token,
    locationId
  ],
  unassignedTurbines: token => [...all, 'unassigned-turbines', token],
  powerSites: token => [...all, 'power-sites', token],
  installedProducts: (token, siteId) => [
    ...all,
    'installed-products',
    token,
    siteId
  ],
  dataPoints: token => [...all, 'data-points', token],
  locationsWithAccessLevels: (token, username) => [
    ...all,
    'locations-with-access-levels',
    token,
    username
  ]
};
